import { render, staticRenderFns } from "./ListFile.vue?vue&type=template&id=587881b9&scoped=true&lang=pug&"
import script from "./ListFile.vue?vue&type=script&lang=js&"
export * from "./ListFile.vue?vue&type=script&lang=js&"
import style0 from "./ListFile.vue?vue&type=style&index=0&id=587881b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587881b9",
  null
  
)

export default component.exports